import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { COMPANY, NAV_LINKS } from "../data/mock";
import { Logo } from "./Illustrations";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  // On the hero (not scrolled) the navbar sits over the purple gradient -> white text.
  const overHero = !scrolled;
  const textClass = overHero ? "text-white" : "text-[#3d3b54]";

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="aaa-container flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => handleNav(e, "body")}
          className="flex items-center gap-3"
        >
          <Logo className="w-9 h-9" light={overHero} />
          <span
            className={`font-display text-lg md:text-xl font-500 tracking-tight ${textClass}`}
            style={{ fontWeight: 500 }}
          >
            {COMPANY.name}
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNav(e, link.href)}
              className={`text-[0.95rem] transition-colors duration-200 ${
                overHero
                  ? "text-white/90 hover:text-white"
                  : "aaa-link"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <button
          className={`md:hidden ${textClass}`}
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white shadow-lg border-t border-gray-100 mt-3">
          <nav className="flex flex-col py-2">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNav(e, link.href)}
                className="aaa-link px-6 py-3 hover:bg-gray-50"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
